module.exports = __webpack_public_path__ + "static/step4-c2237c23425fc3bb695f5e673b3df594.png";